<form [formGroup]="form" class="grid grid-cols-12 flex-col gap-7">
    <section class="col-span-12">
        <span class="text-primary-800 text-3xl"
            >Select a public safety coordinator below.</span
        >
    </section>
    @for (
        formServiceSelectionOption of formServiceSelectionOptions;
        track formServiceSelectionOption.id
    ) {
        <section class="form-card-container">
            <app-submit-to-ewa-form-option
                [formOption]="formServiceSelectionOption"
                [selected]="
                    formServiceSelectionOption ===
                    this.selectedFormOptionSubject.getValue()
                "
                [hasErrorHighlight]="
                    !this.selectedFormOptionSubject.getValue() && form.touched
                "
                (serviceSelected)="handleServiceSelection($event)"
            ></app-submit-to-ewa-form-option>
        </section>
    }
    @if (shouldDisplayAlternatePublicSafetyCoordinatorDropdown()) {
        <section class="form-card-container">
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Alternate Public Safety Coordinator</mat-label>
                <mat-select formControlName="publicSafetyCoordinator">
                    @for (
                        publicSafetyCoordinator of publicSafetyCoordinatorDropdownOptions;
                        track publicSafetyCoordinator.value
                    ) {
                        <mat-option [value]="publicSafetyCoordinator.value">{{
                            publicSafetyCoordinator.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </section>
    }
    <section class="form-card-container">
        <app-submit-to-ewa-form-submission
            (submitForm)="handoverToEwaSubmission()"
            [disableSubmission]="!enableSubmission()"
            [submitButtonLabel]="'Save & Complete'"
        >
        </app-submit-to-ewa-form-submission>
    </section>
</form>
